import type { ScheduleNote } from "@/adapters/api";
import type { Note } from "../types.ts";

export function toNote(item: ScheduleNote): Note {
	return {
		id: item.id,
		stageId: item.stage_id || undefined,
		stageName: item.stage_name || undefined,
		severity: item.severity,
		body: item.body,
		resolvedAt: item.resolved_at ?? undefined,
		createdByName: item.created_by_name,
		createdAt: item.created_at,
	};
}
